import { FC, useEffect, useState } from "react";
import { Button, Input, Form, message } from "antd";
import { useNavigate } from "react-router-dom";
import Card from "antd/es/card/Card";
import { ConnexionRequest } from "../../shared/types/request/connexion.model";
import { TokenValid } from "../../shared/types/request/tokenvalid.model";
import { useConnexion, useIsTokenValid } from "../../shared/services/security/security.service";

const Connexion: FC = () => {

    const navigate = useNavigate()

    function naviguerVersCreationUtilisateur(){
        navigate("/creationcompte")
    }

    function naviguerVersForgetPassword(){
        navigate("/forgetpassword")
    }

    const[tokenRequest, setTokenRequest] = useState<TokenValid>();

    const {dataToken} = useIsTokenValid(tokenRequest);

    useEffect(() => {
        if(localStorage.getItem("username") && localStorage.getItem("token")){
            const request: TokenValid = {
                username: localStorage.getItem("username") || "",
                token: localStorage.getItem("token") || ""
            };
            setTokenRequest(request);
        }
    }, [])

    useEffect(() => {
        if(dataToken){
            navigate("/espaceuser");
        }
    }, [dataToken])
    

    const[formValues, setFormValues] = useState<ConnexionRequest>();

    const {data, isLoading, error} = useConnexion(formValues);

    const onFinish = (values: ConnexionRequest) => {
        setFormValues(values);
    }

    const[messageApi, contextHolder] = message.useMessage();

    useEffect(() =>{
        if(error && error.response.data.erreur){
            messageApi.error(error.response.data.erreur);
        }else{
            if(error)
            {
                messageApi.error(error.message);
            }
        }
    }, [error])

    useEffect(() => {
        if(data && data.token && formValues){
            localStorage.setItem("token", data.token);
            localStorage.setItem("username", formValues.username)
            // TODO - Solution temporaire !
            window.location.reload();
        }
    }, [data])

    return (
        <Card className="responsive-card" title={<span style={{ textAlign: "center" }}>Bienvenue sur l'écran de connexion !</span>} variant="borderless">
            {contextHolder}
            <Form layout="vertical" onFinish={onFinish}>
                <Form.Item
                    label="Nom d'utilisateur"
                    name="username"
                    rules={[{required: true, message: "Nom requis"}]}
                >
                    <Input style={{width: "80%"}} placeholder="Nom d'utilisateur" />
                </Form.Item>


                <Form.Item
                    label="Mot de passe"
                    name="password"
                    rules={[{required: true, message: "Mot de passe requis"}]}>
                        <Input.Password style={{width: "80%"}} placeholder="Entrer le mot de passe" />
                </Form.Item>

                <Button type="primary" loading={isLoading} htmlType="submit">
                    Se connecter
                </Button>
            </Form>
            <Button onClick={naviguerVersCreationUtilisateur} style={{ marginTop: "24px" }}>Créer un compte</Button>
            <br /><br />
            <a onClick={naviguerVersForgetPassword}>Nom d'utilisateur / Mot de passe oublié ?</a>
        </Card>
    )
}

export default Connexion;

